import { LayoutDirection } from './enums';

export interface LayoutConfigs {
	/**
	 * Direction/orientation of the layout
	 */
	direction?: LayoutDirection;
}
